const splitUrl = (urlString) => {
  const [baseUrl] = urlString.split(/[#?]/);
  const urlSearchParams = new URL(urlString, location.href).searchParams;
  return [baseUrl, urlSearchParams];
};

// Params can be in either format:
//   Standard: [{ param: "name", value: value }, ...]
//   Convenience: {name: value, ...}
// This converts all params to Standard format
const standardizeParams = (params) => {
  return Array.isArray(params)
    ? params
    : Object.entries(params).flatMap(([param, value]) => {
        if (Array.isArray(value) && value.length === 0) {
          return { param: `${param}[]`, value: null };
        } else if (Array.isArray(value)) {
          return value.map((v) => ({ param: `${param}[]`, value: v }));
        } else {
          return { param, value };
        }
      });
};

// addQueryParam('/browse', 'category', 'ovens') -> '/browse?category=ovens'
export const addQueryParam = (url, param, value) => {
  const [baseUrl, urlSearchParams] = splitUrl(url);
  value !== null && value !== undefined && urlSearchParams.append(param, value);
  return baseUrl + `?${urlSearchParams.toString()}`;
};

// addQueryParams('/browse', [{value: 'category', param: 'ovens'}, {value: 'type', param: 'electric'}])
// -> '/browse?category=ovens&type=electric'
export const addQueryParams = (url, paramValuePairs) => {
  const [baseUrl, urlSearchParams] = splitUrl(url);
  standardizeParams(paramValuePairs).forEach(({ param, value }) => {
    value !== null && value !== undefined && urlSearchParams.append(param, value);
  });
  return baseUrl + `?${urlSearchParams.toString()}`;
};

// removeQueryParam('/browse?category=ovens', 'category') -> '/browse'
export const removeQueryParam = (url, param) => {
  const [baseUrl, urlSearchParams] = splitUrl(url);
  urlSearchParams.delete(param);
  return baseUrl + (urlSearchParams.toString() ? `?${urlSearchParams.toString()}` : '');
};

export const removeQueryParams = (url, removeParams) => {
  const [baseUrl, urlSearchParams] = splitUrl(url);
  removeParams.forEach((param) => {
    urlSearchParams.delete(param);
  });
  return baseUrl + (urlSearchParams.toString() ? `?${urlSearchParams.toString()}` : '');
};

// replaceQueryParam('/browse?category=ovens', 'category', 'thermostats') -> '/browse?category=thermostats'
export const replaceQueryParam = (url, param, value) => {
  return replaceQueryParams(url, [{ param, value }]);
};

export const replaceQueryParams = (url, params) => {
  const paramNames = standardizeParams(params).map(({ param }) => param);
  const strippedUrl = removeQueryParams(url, paramNames);
  return addQueryParams(strippedUrl, params);
};

export const getQueryParam = (url, param) => {
  const [baseUrl, urlSearchParams] = splitUrl(url);
  return urlSearchParams.get(param);
};

export const getQueryParams = (url) => {
  const [baseUrl, urlSearchParams] = splitUrl(url);
  return urlSearchParams;
};

export const keepPageParams = (url) => {
  const significantParams = ['page', 'product_id', 'resource_id'];
  const [baseUrl, urlSearchParams] = splitUrl(url);
  Array.from(urlSearchParams.entries()).forEach(([key, value]) => {
    if (key == 'page' && value == '1') {
      urlSearchParams.delete(key);
    }
    if (!significantParams.includes(key)) {
      urlSearchParams.delete(key);
    }
  });
  return baseUrl + (urlSearchParams.toString() ? `?${urlSearchParams.toString()}` : '');
};
